import React, { useState } from 'react';
import { Button } from './Button';
import { motion } from 'framer-motion';
import { ChevronDownIcon, ChevronUpIcon, CheckIcon, TargetIcon, ArrowRightIcon, ArrowDownIcon, FileTextIcon, AlertTriangleIcon, GiftIcon, SendIcon, XIcon } from 'lucide-react';
import emailjs from '@emailjs/browser';
export const WhyHereSection: React.FC = () => {
  const scrollToTrainingPlans = () => {
    const element = document.getElementById('plan-cards');
    if (element) {
      const navbarHeight = 80; // Height of fixed navbar
      const additionalOffset = 20; // Extra spacing for better visibility
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navbarHeight - additionalOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  const scrollToSuperfoods = () => {
    const element = document.getElementById('greens');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const [showMoreInfo1, setShowMoreInfo1] = useState(false);
  const [showMoreInfo2, setShowMoreInfo2] = useState(false);
  const [showMoreInfo3, setShowMoreInfo3] = useState(false);
  const [isRedirectingTips, setIsRedirectingTips] = useState(false);
  const handleGetFreeTips = () => {
    setIsRedirectingTips(true);
    setTimeout(() => {
      window.location.href = 'https://buy.stripe.com/fZu3cucIH7LY6wt2vAg7e03';
      // Neodstraňujeme loading screen - zůstane až do přesměrování
    }, 3000);
  };
  return <section className="section section-darker relative py-24" id="why-here" data-id="element-1346">
      {/* Loading Screen for Free Tips */}
      {isRedirectingTips && <div className="fixed inset-0 bg-black/95 backdrop-blur-sm flex items-center justify-center z-50" data-id="element-1347">
          <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="text-center" data-id="element-1348">
            <motion.div animate={{
          rotate: 360
        }} transition={{
          duration: 1,
          repeat: Infinity,
          ease: 'linear'
        }} className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full mx-auto mb-6" data-id="element-1349" />

            <h3 className="text-2xl font-bold mb-2 text-white" data-id="element-1350">
              Přesměrová na PDF s tipy pro rychlejší progress
            </h3>
            <p className="text-gray-400" data-id="element-1351">
              moment prosím, připravujeme Vaše PDF
            </p>
          </motion.div>
        </div>}
      <div className="container mx-auto px-4 section-content" data-id="element-1352">
        <div className="flex flex-col md:flex-row gap-16 items-center" data-id="element-1353">
          <div className="w-full md:w-1/2 order-2 md:order-1" data-id="element-1354">
            <motion.h3 initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.6
          }} viewport={{
            once: true
          }} className="text-xl md:text-3xl font-black mb-8 leading-tight" data-id="element-1355">
              Jsi začátečník nebo už nějakou dobu cvičíš, ale{' '}
              <span className="text-green-500" data-id="element-1356">pořád to není ono</span>? Nevidíš
              výsledky, <span className="text-green-500" data-id="element-1357">jaké by sis přál</span>
              ? Nebo cvičíš už delší dobu, ale máš pocit, že se neposouváš{' '}
              <span className="text-green-500" data-id="element-1358">tak jako dřív</span>?
            </motion.h3>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} viewport={{
            once: true
          }} className="relative mb-12 z-10" data-id="element-1359">
              <div className="bg-gradient-to-br from-gray-900 to-black p-8 rounded-xl shadow-[0_20px_50px_-12px_rgba(34,197,94,0.3)] border border-green-500/30 relative overflow-hidden backdrop-blur-sm" data-id="element-1360">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-green-500 to-transparent" data-id="element-1361"></div>
                <div className="absolute -top-20 -right-20 w-40 h-40 bg-green-500/10 rounded-full filter blur-3xl" data-id="element-1362"></div>
                <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-green-500/5 rounded-full filter blur-3xl" data-id="element-1363"></div>
                <h4 className="text-xl md:text-2xl font-black mb-6 flex items-center bg-clip-text text-transparent bg-gradient-to-r from-white via-green-300 to-white" data-id="element-1364">
                  <TargetIcon className="w-6 h-6 md:w-7 md:h-7 text-green-500 mr-3 flex-shrink-0" data-id="element-1365" />
                  <span data-id="element-1366">Tvoje cesta začíná tady</span>
                </h4>
                <div className="space-y-6 relative z-10" data-id="element-1367">
                  <p className="text-sm md:text-base leading-relaxed" data-id="element-1368">
                    Tady dostaneš{' '}
                    <span className="font-bold text-green-400 px-1 py-0.5 rounded bg-green-500/10" data-id="element-1369">
                      přesný tréninkový plán
                    </span>
                    , navržený podle tvé aktuální úrovně v posilovně. Žádné
                    obecné rady nebo "zázračné" cviky. Celý tréninkový plán je
                    postavený jak na mých vlastních zkušenostech z posilovny,
                    tak na{' '}
                    <span className="font-bold text-white underline decoration-green-500 decoration-2 underline-offset-2" data-id="element-1370">
                      ověřených studiích
                    </span>
                    , které mi pomáhali v průběhu několika roků cvičení.
                  </p>
                  <div className="h-px w-full bg-gradient-to-r from-transparent via-green-500/50 to-transparent" data-id="element-1371"></div>
                  <p className="text-sm md:text-base leading-relaxed" data-id="element-1372">
                    Studie, které mi napomáhali při tvorbě tréninkových plánů,
                    byly pečlivě vybrané – a jejich účinnost byla ověřena{' '}
                    <span className="font-bold text-white" data-id="element-1373">
                      několika tisíci lidmi po celém světě
                    </span>
                    . Cíl plánu je jediný:
                  </p>
                </div>
                <div className="mt-6 bg-gradient-to-r from-green-900/40 via-green-800/40 to-green-900/40 p-4 rounded-lg border border-green-500/30 transform hover:scale-[1.02] transition-transform duration-300" data-id="element-1374">
                  <p className="text-base md:text-xl font-black text-center text-white" data-id="element-1375">
                    Co nejrychlejší výsledky v{' '}
                    <span className="text-green-400" data-id="element-1376">co nejkratším období</span>{' '}
                    (3 měsíce)
                  </p>
                </div>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.5
          }} viewport={{
            once: true
          }} className="p-4 md:p-6 bg-gray-900 rounded-xl border-l-4 border-green-500 luxury-card mb-4 md:mb-6" data-id="element-1377">
              <p className="text-sm md:text-base font-bold mb-2" data-id="element-1378">
                Proč je většina trenérů a subscription plánů nastavená tak, aby
                ses nikdy nenaučil cvičit sám?
              </p>
              <div data-id="element-1379">
                <button onClick={() => setShowMoreInfo1(!showMoreInfo1)} className="text-green-500 hover:text-green-400 transition-colors text-xs md:text-sm font-medium flex items-center" data-id="element-1380">
                  {showMoreInfo1 ? <>
                      <span className="text-xs" data-id="element-1381">Méně</span>
                      <ChevronUpIcon className="ml-1 w-4 h-4" data-id="element-1382" />
                    </> : <>
                      <span className="text-xs" data-id="element-1383">Více...</span>
                      <ChevronDownIcon className="ml-1 w-4 h-4" data-id="element-1384" />
                    </>}
                </button>
                <motion.div initial={false} animate={{
                height: showMoreInfo1 ? 'auto' : 0,
                opacity: showMoreInfo1 ? 1 : 0,
                marginTop: showMoreInfo1 ? 16 : 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-1385">
                  <p className="text-gray-300 text-xs md:text-sm mb-3" data-id="element-1386">
                    Protože jejich byznys stojí na tom, že jim budeš platit
                    pořád. A jakmile jednou pochopíš, jak trénink opravdu
                    funguje, přestaneš je potřebovat. Subscription plán
                    potřebuje, abys každý měsíc znovu vytáhl kartu. Soukromý
                    trenér potřebuje, aby sis pořád myslel, že bez něj to nejde.
                    A proto ti většina z nich nikdy nedá kompletní know-how.
                  </p>
                  <p className="text-gray-300 text-xs md:text-sm mb-3" data-id="element-1387">
                    Schválně ti dají pocit, že trénink je strašně složitý.
                    Neustále mění cviky, variace, kombinace, aby to vypadalo
                    odborně. Jenže výsledkem je, že se v tom začneš ztrácet.
                    Nemáš žádný systém. Nemáš žádný jasný progres. Nemáš co
                    trackovat. A když nemáš co měřit, nemůžeš růst. Studie na
                    základě, kterých jsem tvořil moje plány dokazují, že čím
                    jednodušší plán/trénink je, tím rychlejší výsledky má
                    člověk, díky jednoduchému zaznamenávání si progressu. To
                    úplně nesedí se stylem trénovaní trenéru/online plánů, že
                    ano?
                  </p>
                  <p className="text-gray-300 text-xs md:text-sm mb-3" data-id="element-1388">
                    A přesně tady vzniká stagnace. Ne proto, že bys byl líný. Ne
                    proto, že bys málo makal. Ale protože cvičíš podle něčeho,
                    co je udělané tak, aby tě udrželo v kruhu. Děláš pořád něco
                    jiného, takže nikdy nevidíš reálný posun ve výkonu. A když
                    nevidíš posun ve výkonu, tvoje tělo nemá důvod růst.
                  </p>
                  <p className="text-gray-300 text-xs md:text-sm" data-id="element-1389">
                    A pak přijde ten nejhorší výsledek: ztrácíš čas. Makáš roky,
                    ale pořád vypadáš podobně. Ztrácíš motivaci. A hlavně
                    ztrácíš peníze, protože čím víc stagnuješ, tím víc začneš
                    hledat další plán, dalšího trenéra, další „zázračnou
                    metodu". Jenže to nikdy neskončí, dokud nedostaneš systém,
                    který tě naučí přemýšlet jako trenér a růst podle jasných
                    pravidel.
                  </p>
                </motion.div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.5
          }} viewport={{
            once: true
          }} className="p-4 md:p-6 bg-gray-900 rounded-xl border-l-4 border-green-500 luxury-card mb-4 md:mb-6" data-id="element-1390">
              <p className="text-sm md:text-base font-bold mb-2" data-id="element-1391">
                Proč ti můj plán dá za 3 měsíce systém, výsledky a know-how,
                které jinde získáš až za roky?
              </p>
              <div data-id="element-1392">
                <button onClick={() => setShowMoreInfo2(!showMoreInfo2)} className="text-green-500 hover:text-green-400 transition-colors text-xs md:text-sm font-medium flex items-center" data-id="element-1393">
                  {showMoreInfo2 ? <>
                      <span className="text-xs" data-id="element-1394">Méně</span>
                      <ChevronUpIcon className="ml-1 w-4 h-4" data-id="element-1395" />
                    </> : <>
                      <span className="text-xs" data-id="element-1396">Více...</span>
                      <ChevronDownIcon className="ml-1 w-4 h-4" data-id="element-1397" />
                    </>}
                </button>
                <motion.div initial={false} animate={{
                height: showMoreInfo2 ? 'auto' : 0,
                opacity: showMoreInfo2 ? 1 : 0,
                marginTop: showMoreInfo2 ? 16 : 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-1398">
                  <p className="text-gray-300 text-xs md:text-sm mb-3" data-id="element-1399">
                    Protože já mám přesně opačný záměr než většina trhu. Já
                    nechci, abys na mně byl závislý. Nechci, abys za rok platil
                    znovu. Nechci ti prodávat „motivaci". Já ti dávám přesný
                    systém, který tě za 3 měsíce dovede do bodu, kdy budeš
                    schopný cvičit sám a růst dál bez toho, aby sis kdy znovu
                    musel platit plán nebo trenéra.
                  </p>
                  <p className="text-gray-300 text-xs md:text-sm mb-3" data-id="element-1400">
                    Můj plán není chaos. Je to opak chaosu. Je to jasně daný
                    tréninkový pattern, který se opakuje tak, aby ses v něm
                    zlepšoval každý týden. Právě díky tomu začneš poprvé v
                    životě chápat, že svaly nerostou z náhodných cviků, ale z
                    progresu. Z toho, že se zlepšuješ v těch samých pohybech, ve
                    stejném systému, a přesně víš, co máš dělat.
                  </p>
                  <p className="text-gray-300 text-xs md:text-sm mb-3" data-id="element-1401">
                    Tohle je rozdíl mezi lidmi, kteří cvičí roky a pořád
                    nevypadají, a lidmi, kteří během pár měsíců vystřelí. Jedna
                    věc. Systém. Přesná strategie. A důsledné trackování, které
                    tě donutí zlepšovat se, protože máš čísla před sebou a
                    vidíš, co se děje.
                  </p>
                  <p className="text-gray-300 text-xs md:text-sm mb-3" data-id="element-1402">
                    Já jsem si na tohle musel přijít sám. Několik let pokusů a
                    omylů. Studoval jsem věci, které běžný člověk v posilovně
                    nikdy řešit nebude. A právě proto jsem udělal tenhle plán –
                    abys nemusel ztratit roky života tím, že budeš hádat, co
                    funguje a co ne.
                  </p>
                  <p className="text-gray-300 text-xs md:text-sm" data-id="element-1403">
                    Ty u mě nedostaneš jen „cviky". Dostaneš know-how. Dostaneš
                    postup. Dostaneš vysvětlení, proč přesně tohle děláš, jaký
                    to má smysl, jak to ovlivní tvůj růst a jak tohle jednou
                    budeš schopný postavit i sám. A pokud budeš konzistentní,
                    tak po třech měsících nebudeš jen vypadat jinak. Budeš mít v
                    hlavě systém, který ti zůstane do konce života.
                  </p>
                </motion.div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.6
          }} viewport={{
            once: true
          }} className="p-4 md:p-6 bg-gray-900 rounded-xl border-l-4 border-green-500 luxury-card mb-6 md:mb-8" data-id="element-1404">
              <p className="text-sm md:text-base font-bold mb-2" data-id="element-1405">
                Proč je jednorázová platba za 3 měsíce jediná finančně chytrá
                volba oproti trenérovi nebo subscription?
              </p>
              <div data-id="element-1406">
                <button onClick={() => setShowMoreInfo3(!showMoreInfo3)} className="text-green-500 hover:text-green-400 transition-colors text-xs md:text-sm font-medium flex items-center" data-id="element-1407">
                  {showMoreInfo3 ? <>
                      <span className="text-xs" data-id="element-1408">Méně</span>
                      <ChevronUpIcon className="ml-1 w-4 h-4" data-id="element-1409" />
                    </> : <>
                      <span className="text-xs" data-id="element-1410">Více...</span>
                      <ChevronDownIcon className="ml-1 w-4 h-4" data-id="element-1411" />
                    </>}
                </button>
                <motion.div initial={false} animate={{
                height: showMoreInfo3 ? 'auto' : 0,
                opacity: showMoreInfo3 ? 1 : 0,
                marginTop: showMoreInfo3 ? 16 : 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-1412">
                  <p className="text-gray-300 text-xs md:text-sm mb-3" data-id="element-1413">
                    Protože když se na to podíváš logicky, tak je to úplně
                    absurdní rozdíl.
                  </p>
                  <p className="text-gray-300 text-xs md:text-sm mb-3" data-id="element-1414">
                    Subscription plán tě může stát klidně 1 500 Kč měsíčně. A co
                    je horší – i když ho budeš platit rok, stejně pořád nebudeš
                    vědět, jak si trénink postavit sám. Protože subscription
                    model je nastavený tak, aby tě udržel v placení. Platíš
                    dlouhodobě a pořád jsi ve stejné pozici.
                  </p>
                  <p className="text-gray-300 text-xs md:text-sm mb-3" data-id="element-1415">
                    Soukromý trenér je ještě větší extrém. Pokud chceš chodit
                    pětkrát týdně, i kdyby si řekl jen 500 Kč za hodinu, tak jsi
                    na 10 000 Kč měsíčně. Za tři měsíce jsi na 30 000 Kč. A co
                    se stane potom? Trenér ti řekne, že je potřeba pokračovat.
                    Další měsíc. Další balíček. Další peníze. A pořád jsi pořád
                    v systému, kde někoho platíš, aby tě vedl, místo toho, aby
                    ses to naučil sám.
                  </p>
                  <p className="text-gray-300 text-xs md:text-sm mb-3" data-id="element-1416">
                    Moje filozofie je přesně opačná. Jednorázová platba. Konec.
                    Já jsem si mohl vybrat subscription model a vydělával bych
                    na lidech dlouhodobě. Bylo by to pro mě jednodušší. Ale já
                    jsem si vybral nejhorší možný business model pro mě – a
                    nejlepší možný pro tebe. Protože vím, že tři měsíce stačí na
                    to, aby člověk získal reálný progres a know-how.
                  </p>
                  <p className="text-gray-300 text-xs md:text-sm" data-id="element-1417">
                    Za 1 799 až 1 999 Kč dostaneš 3 měsíce systému, který ti dá
                    výsledky a naučí tě přesně to, co ti ostatní nikdy neřeknou.
                    A po skončení už nebudeš muset platit nic. Žádné
                    subscription, žádné další plány, žádné trenéry. Protože
                    budeš vědět, jak trénovat a jak se dál posouvat sám.
                  </p>
                  <p className="text-gray-300 text-xs md:text-sm" data-id="element-1418">
                    A to je důvod, proč je moje cesta jediná, která dává smysl.
                    Nejen fyzicky. Ale logicky. Časově. Finančně. A dlouhodobě.
                  </p>
                </motion.div>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.7
          }} viewport={{
            once: true
          }} data-id="element-1419">
              <Button variant="primary" size="lg" onClick={scrollToTrainingPlans} className="luxury-button w-full text-sm md:text-base" data-id="element-1420">
                ZAČNI TEĎ!
              </Button>
            </motion.div>
          </div>
          <div className="w-full md:w-1/2 order-1 md:order-2" data-id="element-1421">
            <motion.div initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.8
          }} viewport={{
            once: true
          }} className="relative overflow-hidden rounded-xl shadow-2xl h-full" data-id="element-1422">
              <img src="https://cdn.magicpatterns.com/uploads/edqQdf8r8ChUyXMsBE3DfS/Ondra-31_28229.jpg" alt="Tréninkový plán" className="w-full h-full object-cover transform transition-all duration-700 hover:scale-105" data-id="element-1423" />

              <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent" data-id="element-1424"></div>
              <div className="absolute inset-0 bg-gradient-to-b from-black via-transparent to-transparent opacity-70" style={{
              height: '30%'
            }} data-id="element-1425"></div>
            </motion.div>
          </div>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true
      }} className="mt-8 md:mt-8 relative z-10" data-id="element-1426">
          <div className="bg-gradient-to-b from-gray-900 to-gray-800 rounded-2xl p-5 md:p-7 shadow-[0_20px_50px_-12px_rgba(34,197,94,0.25)] border-t border-green-500/30 max-w-4xl mx-auto overflow-hidden" data-id="element-1427">
            <div className="absolute top-0 left-0 right-0 mx-auto w-3/4 md:w-1/2 h-1 bg-gradient-to-r from-transparent via-green-500 to-transparent" data-id="element-1428"></div>
            <div className="absolute -top-16 -left-16 w-32 h-32 bg-green-500/10 rounded-full filter blur-3xl" data-id="element-1429"></div>
            <div className="absolute -bottom-16 -right-16 w-32 h-32 bg-green-500/10 rounded-full filter blur-3xl" data-id="element-1430"></div>
            <h3 className="text-lg md:text-2xl font-black mb-3 leading-tight text-center bg-clip-text text-transparent bg-gradient-to-r from-white via-green-300 to-white" data-id="element-1431">
              Přístup k vysněné postavě
            </h3>
            <p className="text-xs md:text-lg font-medium mb-4 text-center leading-relaxed" data-id="element-1432">
              Nezáleží na tom, jestli jsi začátečník, pokročilý nebo
              profesionál. Každý plán je vytvořený individuálně, tak aby ses z
              tvé aktuální pozice posouval co{' '}
              <span className="text-green-400" data-id="element-1433">nejrychleji kupředu</span>.
            </p>
            <div className="flex flex-col items-center" data-id="element-1434">
              <motion.div className="mb-3 md:mb-4" initial={{
              y: 0
            }} animate={{
              y: [0, -10, 0]
            }} transition={{
              repeat: Infinity,
              duration: 2,
              ease: 'easeInOut'
            }} data-id="element-1435">
                <ArrowDownIcon className="w-5 h-5 md:w-8 md:h-8 text-green-500" data-id="element-1436" />
              </motion.div>
              <Button variant="primary" size="lg" onClick={scrollToTrainingPlans} className="shine text-xs md:text-base px-4 py-2 md:px-6 md:py-3" data-id="element-1437">
                VYBER SI SVŮJ PLÁN
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};